enum SubscriptionItemServiceCodes {
  PageImport = 'pageImport',
  CptCodesAccess = 'cptCodesAccess',
};

export default SubscriptionItemServiceCodes;
